import {
  isReplaceImageRule,
  isReplaceImageWithVariableRule,
} from '@carboncopyco/editor-utils';
import { memo, useMemo } from 'react';
import {
  useEditor,
  useEditorFindAndReplaceRules,
  useEditorVariables,
} from '../context/EditorSdkProvider';
import { useEditorTool } from '../hooks/useEditorTool';
import { FindAndReplaceManager } from '../ui/FindAndReplaceManager';

export const FindAndReplaceManagerTool = memo(() => {
  const editorSdk = useEditor();
  const {
    rules,
    createFindAndReplaceRule,
    editFindAndReplaceRule,
    deleteFindAndReplaceRule,
    reorderFindAndReplaceRules,
  } = useEditorFindAndReplaceRules();
  const { variables } = useEditorVariables();
  const { isOpen, close } = useEditorTool('findReplace');

  const modifiedRules = useMemo(() => {
    const { filesServiceDomain } = editorSdk;
    return rules.map((rule) => {
      if (isReplaceImageRule(rule)) {
        return {
          ...rule,
          sourceFileServiceLink: `${filesServiceDomain}${rule.sourceFileServiceLink}`,
          destinationFileServiceLink: `${filesServiceDomain}${rule.destinationFileServiceLink}`,
        };
      }
      if (isReplaceImageWithVariableRule(rule)) {
        return {
          ...rule,
          sourceFileServiceLink: `${filesServiceDomain}${rule.sourceFileServiceLink}`,
        };
      }

      return rule;
    });
  }, [editorSdk, rules]);

  return (
    <FindAndReplaceManager
      isOpen={isOpen}
      onClose={close}
      rules={modifiedRules}
      variables={variables}
      createRule={createFindAndReplaceRule}
      editRule={editFindAndReplaceRule}
      deleteRule={deleteFindAndReplaceRule}
      onLearnMoreClick={editorSdk.openUrlLink}
      reorderRules={reorderFindAndReplaceRules}
    />
  );
});

FindAndReplaceManagerTool.displayName = 'FindAndReplaceManagerTool';
